import Debug from 'debug'
import RESTResource from '../rest/RESTResource.js'
import protectedSymbol from '../util/protected.js'

const debug = Debug('cbio.Account')

export default class Account extends RESTResource {
  constructor (api, resource = {}) {
    super(api, resource)
    debug('constructed Account')
  }

  static url (state = {}) {
    return `/api/1/accounts/${state.id || ''}`
  }

  #field = (key) => {
    return this[protectedSymbol].field(key)
  }

  get license_key () {
    return this.#field('license_key')
  }

  get features () {
    return this.#field('features')
  }

  toJSON = () => {
    return {
      id: this.id,
      license_key: this.license_key,
      features: this.features
    }
  }
}
